var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:['material-icons-round v-icon', { 'rtl-flip': _vm.rtlFlip }],style:({
    fontSize: _vm.size,
    color: _vm.color
  }),attrs:{"translate":"no"}},[_vm._v(" "+_vm._s(_vm.icon)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }